import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const toggleLockStructure: YJSChangeHandler<
  DatabaseChangeType.TOGGLE_LOCK_STRUCTURE
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.isLocked = change.newValue;
  });
};
